import React from 'react';
import { AdminHeader, AdminSidebar } from 'components';
import { AnnualLeaveAllocationForm } from 'components/organisms/AnnualLeaveAllocationForm';

export const AnnualLeaveAllocation = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <AnnualLeaveAllocationForm />
      </div>
    </>
  );
};
